import axios from 'axios';

// Create axios instance with base URL and credentials
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';
console.log('🔧 API Base URL:', API_BASE_URL);

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // This is important for cookies
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to handle errors
api.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// CSRF token functionality removed - using JWT authentication instead

// Add request interceptor to add auth token
api.interceptors.request.use(async (config) => {
  // Add JWT token if available
  const token = localStorage.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

// Authentication API calls
export const authAPI = {
  register: (userData: any) => api.post('/auth/register', userData),
  login: (credentials: any) => api.post('/auth/login', credentials),
  complete2FALogin: (token: string, sessionId: string) => 
    api.post('/auth/complete-2fa-login', { token, sessionId }),
  getCurrentUser: () => api.get('/auth/me'),
  generate2FASecret: () => api.post('/auth/2fa/generate'),
  verify2FA: (token: string) => api.post('/auth/2fa/verify', { token }),
  disable2FA: () => api.post('/auth/2fa/disable'),
};

// Document API calls
export const documentAPI = {
  getAll: () => api.get('/documents'),
  getById: (id: string) => api.get(`/documents/${id}`),
  create: (documentData: any) => api.post('/documents', documentData),
  update: (id: string, documentData: any) => api.put(`/documents/${id}`, documentData),
  delete: (id: string) => api.delete(`/documents/${id}`),
  share: (id: string, userData: any) => api.post(`/documents/${id}/share`, userData),
};

// Template API calls
export const templateAPI = {
  getAll: () => api.get('/templates'),
  getById: (id: string) => api.get(`/templates/${id}`),
  create: (templateData: any) => api.post('/templates', templateData),
  update: (id: string, templateData: any) => api.put(`/templates/${id}`, templateData),
  delete: (id: string) => api.delete(`/templates/${id}`),
};

// AI API calls
export const aiAPI = {
  improveClause: (text: string) => api.post('/ai/improve-clause', { text }),
  analyzeRisks: (text: string) => api.post('/ai/analyze-risks', { text }),
  suggestAlternatives: (text: string) => api.post('/ai/suggest-alternatives', { text }),
  simplifyText: (text: string) => api.post('/ai/simplify-text', { text }),
};

export default api; 